import EventsWidgetListing from './EventsWidgetListing';

export default EventsWidgetListing;
